<template>
  <div class="basicInfo bg-white">
    <div class="img-card">
      <q-img
        class="full-width img"
        :ratio="1"
        lazy="loading"
        :src="info.image && $ossLimit(info.image)"
        spinner-color="white"
        placeholder-src="https://static.bakmigm.co.id/menu/00110000/Default.jpg"
      />
      <div
        v-if="!info.inStock"
        class="absolute-full text-subtitle2 flex flex-center instock"
      >
        <q-icon name="app:habisIcon" class="logo" size="100px" />
      </div>
    </div>
    <div bold class="text">
      <h1 break class="text-name">{{ info.name }}</h1>
      <h2 break class="text-desc">
        {{ info.desc }}
      </h2>
      <div class="text-price">
        <span break class="price-normal">{{
          $n(info.finalPrice || 0, 'currency', 'id-ID')
        }}</span>
        <span v-if="promo" break class="price-del">{{
          $pid(info.listPrice)
        }}</span>
        <span v-if="promo" class="price-tag">
          <i class="iconfont dm-Tag" /> {{ $t('list.promo') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      inStock: true,
    };
  },
  computed: {
    promo() {
      return this.info.listPrice !== this.info.finalPrice;
    },
  },
};
</script>

<style lang="scss">
.basicInfo {
  .q-img[lazy='loading'] {
    /*your style here*/
    background-image: url('../../../assets/loading/loading.gif');
    background-size: auto;
    background-repeat: no-repeat;
    background-position: center;
  }
  .img-card {
    background-size: cover;
    position: relative;
    .img {
    }
    .instock {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba($color: #000000, $alpha: 0.5);
    }
  }
  .text {
    padding: 16px 16px 24px 16px;
    &-name {
      font-size: $font-size-6;
      line-height: 1.2;
      color: #000;
      font-weight: bold;
      margin: 0;
    }
    &-desc {
      font-size: $font-size-2;
      color: $grayFont;
      line-height: 1.1;
      margin: 12px 0 16px;
    }
    &-price {
      display: flex;
      align-items: flex-end;
      .price-normal {
        font-size: $font-size-6;
        max-width: 250px;
      }
      .price-del {
        font-size: $font-size-2;
        text-decoration: line-through;
        color: $grayFont;
        font-weight: normal;
        margin: 0 0 4px 4px;
        min-width: 50px;
      }
      .price-tag {
        margin-left: auto;
        align-self: center;
        flex-shrink: 0;
        .iconfont {
          font-size: inherit;
        }
        font-size: 12px;
        color: #fff;
        padding: 2px 4px;
        background: $primary;
        border-radius: $border-radius-in;
      }
    }
  }
}
</style>
